var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { cupMountingModels, getCupMountingModelImage, getTubeConnectionModelImage, tubeConnectionMaterialAreaName, tubeConnectionModels, tubeMaterials, } from "3d/constants/common";
import { TubeType } from "store/types";
/* Mountings stand upright, so a low three-quarter view like the pump product
 * images shows their shape best. Couplings lie flat, so they are viewed from
 * higher up to keep every port visible. */
export var cupMountingThumbnailView = {
    azimuth: 35,
    elevation: 20,
    margin: 1.1,
};
export var tubeConnectionThumbnailView = {
    azimuth: 35,
    elevation: 40,
    margin: 1.1,
};
/** Per-model adjustments for models the category default frames badly. */
export var thumbnailViewOverrides = {};
/* The live scene renders a tube connection with the tube material of the tubes
 * plugged into it. A thumbnail has no tubes, so it shows the vacuum colour,
 * which is what most connections carry. */
var tubeConnectionMaterialSwaps = (_a = {},
    _a[tubeConnectionMaterialAreaName] = tubeMaterials[TubeType.VACUUM][0],
    _a);
var unique = function (names) { return Array.from(new Set(names)); };
var createJob = function (category, modelName, imagePath, view, materialSwaps) { return ({
    id: "".concat(category, "/").concat(modelName),
    category: category,
    modelName: modelName,
    imagePath: imagePath,
    view: __assign(__assign({}, view), thumbnailViewOverrides[modelName]),
    materialSwaps: materialSwaps,
}); };
/** One job per distinct 3D model that a cup mounting or tube connection can resolve to. */
export var createThumbnailJobs = function () { return __spreadArray(__spreadArray([], __read(unique(Object.values(cupMountingModels)).map(function (modelName) {
    return createJob("cup-mounting", modelName, getCupMountingModelImage(modelName), cupMountingThumbnailView, {});
})), false), __read(unique(Object.values(tubeConnectionModels).map(function (_a) {
    var modelName = _a.modelName;
    return modelName;
})).map(function (modelName) {
    return createJob("tube-connection", modelName, getTubeConnectionModelImage(modelName), tubeConnectionThumbnailView, tubeConnectionMaterialSwaps);
})), false); };
